import React from "react";
import './App.css'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DashboardPage from "./components/Pages/DashboardPage";
import LoginPage from "./components/Pages/LoginPage";
import SignupPage from "./components/Pages/SignupPage";
import ForgotPasswordPage from "./components/Pages/ForgotPasswordPage";
import NotFound from "./components/common/NotFound";
import ProtectedRoute from "./Context/ProtectedRoute";

import Home from "./components/Dashboard/Home/Home";
import OverviewDashboard from "./components/Dashboard/OverviewDashboard/Overview";
import ActiveEventsHub from "./components/Dashboard/ActiveEventsHub/ActiveEventsHub";
import About from "./components/Dashboard/About/About";

// Cyclone imports
import DisturbanceTrack from "./components/Homepage/Cyclone/DisturbanceTrack/DisturbanceTrack";
import ImpactForecast from "./components/Homepage/Cyclone/ImpactForecast/ImpactForecast";
import OverviewC from "./components/Homepage/Cyclone/ImpactForecast/Overview";
import CycloneAdvisory from "./components/Homepage/Cyclone/ImpactForecast/Cyclone_Advisory";
import ImpactedArea from "./components/Homepage/Cyclone/ImpactForecast/ImpactedArea";
import OceanWave from "./components/Homepage/Cyclone/ImpactForecast/OceanWave";
import Oceanstate from "./components/Homepage/Cyclone/OceanState/OceanState";
import HistoricalCyclone from "./components/Homepage/Cyclone/HistoricalCyclone/HistoricalCyclone";
import AdvisoryCyclone from "./components/Homepage/Cyclone/AdvisoryCyclone/AdvisoryCyclone";
import GISMaps from "./components/Homepage/Cyclone/Exposure/GISMaps/GISMaps";
import TopographicMap from "./components/Homepage/Cyclone/Exposure/TopographicMap/TopographicMap";
import GeneralMaps from "./components/Homepage/Cyclone/Exposure/GeneralMaps/GeneralMaps";
import Comparison from "./components/Homepage/Cyclone/Comparison/Comparison";
import WeatherStation from "./components/Homepage/Cyclone/WeatherStation/WeatherStation";
import SatelliteImagery from "./components/Homepage/Cyclone/SatelliteImagery/SatelliteImagery";
import BulletinEntry from "./components/Homepage/Cyclone/DataPanel/BulletinEntry/BulletinEntry";
import CycloneTrack from "./components/Homepage/Cyclone/DataPanel/CycloneTrack/CycloneTrack";
import UploadJTWC from "./components/Homepage/Cyclone/DataPanel/UploadJTWC/UploadJTWC";
import Cycloneadvisory from "./components/Homepage/Cyclone/DataPanel/Cyclone_advisory/Cyclone_advisory";
import ReportsCY from "./components/Homepage/Cyclone/Reports/Reports";
import FeltReportCY from "./components/Homepage/Cyclone/DataPanel/FeltReport/FeltReport";
import AutoEmailCyclone from "./components/Homepage/Cyclone/Dissemination/AutoEmail/AutoEmail";


// Landslide imports (accessible by all)
import ForecastLS from "./components/Homepage/Landslide/Forecast/Forecast";
import Projections from "./components/Homepage/Landslide/Projections/Projections";
import LandslideAdvisory from "./components/Homepage/Landslide/Advisory/Advisory";
import RainfallForecast from "./components/common/RainfallForecast/RainfallForecast";
import OverviewLS from "./components/Homepage/Landslide/Forecast/Overview";
import ImpactedAreaLS from "./components/Homepage/Landslide/Forecast/ImpactedArea_LS";
import HistoricalDataLS from "./components/Homepage/Landslide/HistoricalData/HistoricalData";
import BathymetrySeamask from "./components/Homepage/Landslide/GeologicalTerrainData/BathymetrySeamask/BathymetrySeamask";
import SoilData from "./components/Homepage/Landslide/GeologicalTerrainData/SoilData/SoilData";
import LandCover from "./components/Homepage/Landslide/GeologicalTerrainData/LandCover/LandCover";
import SoilTexture from "./components/Homepage/Landslide/GeologicalTerrainData/SoilTexture/SoilTexture";
import LSM from "./components/Homepage/Landslide/Susceptibility/LSM/LSM";
import SeasonalWise from "./components/Homepage/Landslide/Susceptibility/SeasonalWise/SeasonalWise";
import HydrologicalDataLS from "./components/Homepage/Landslide/VulnerabilityLS/HydrologicalData/HydrologicalData";
import RoadNetwork from "./components/Homepage/Landslide/ExposurLS/RoadNetwork/RoadNetwork";
import FeltReportLS from "./components/Homepage/Landslide/DataPanel/FeltReport/FeltReport";
import ReportsLS from "./components/Homepage/Landslide/Reports/Reports";
// import AdvisoryLS from "./components/Homepage/Landslide/Advisory/Advisory";
import AutoEmailLandslide from "./components/Homepage/Landslide/Dissemination/AutoEmail/AutoEmail";
import Landslideadvisory from "./components/Homepage/Landslide/DataPanel/Landslide_advisory/Landslide_advisory";

// Earthquake imports
import EqStatistics from "./components/Homepage/Earthquake/Statistics/Statistics";
//import EarthquakeDashboard from "./components/Homepage/Earthquake/Statistics/EarthquakeDashboard";
import RecentEarthquake from "./components/Homepage/Earthquake/RecentEarthquake/RecentEarthquake";
import TsunamiThreat from "./components/Homepage/Earthquake/TsunamiThreat/TsunamiThreat";
import EQAdvisory from "./components/Homepage/Earthquake/Advisory/Advisory";
import FeltReport from "./components/Homepage/Earthquake/FeltReport/FeltReport";
import AutoEmail from "./components/Homepage/Earthquake/AutoEmail/AutoEmail";
import TifLayer from "./components/Homepage/Earthquake/TifLayer/TifLayer";
import EQSettings from "./components/Homepage/Earthquake/DataPanel/Settings/Settings";
import EQEvents from "./components/Homepage/Earthquake/DataPanel/Events/Events";
import ReportList from "./components/Homepage/Earthquake/DataPanel/Reports/Reports";
import RiskInformation from "./components/Homepage/Earthquake/TsunamiThreat/RiskInformation/RiskInformation";

import HealthCenters from "./components/Homepage/Earthquake/HealthCenters/HealthCenters";

// Flood imports
import FloodOverview from "./components/Homepage/Flood/Overview/Overview";
import FFGS from "./components/Homepage/Flood/FFGS/FFGS";
import FDashboard from "./components/Homepage/Flood/Dashboard/Dashboard";
import FlashFlood from "./components/Homepage/Flood/FlashFloodThreat/Overview";
import GeoGlowsForecast from "./components/Homepage/Flood/GeoGlowsForecast/Forecast";
import HydroForecast from "./components/Homepage/Flood/HydrologicalForecast/Forecast";
import Advisory from "./components/Homepage/Flood/Advisory/Advisory";
import ReportsFL from "./components/Homepage/Flood/Reports/Reports";
import ClimateMonitoring from "./components/Homepage/Flood/ClimateMonitoring/ClimateMonitoring";
import Analysis from "./components/Homepage/Flood/Analysis/Analysis";
import AgriculutureData from "./components/Homepage/Flood/Exposure/AgriculutureData/AgriculutureData";
import HydrologicalData from "./components/Homepage/Flood/Exposure/HydrologicalData/HydrologicalData";
import AutoEmailFlood from "./components/Homepage/Flood/AutoEmail/AutoEmail";

// Road Accident imports
import AssistanceOnMove from "./components/Homepage/RoadAccident/Assistanceonmove/Assistanceonmove";
import Overview from "./components/Homepage/RoadAccident/Overview/Overview";
import Roadnetworks from "./components/Homepage/RoadAccident/Roadnetworks/Roadnetworks";
import ExposureRA from "./components/Homepage/RoadAccident/Exposure/ExposureRA";
import AdvisoryRA from "./components/Homepage/RoadAccident/Advisory/AdvisoryRA";
import RoadAccidentDashboard from "./components/Homepage/RoadAccident/RoadAccidentDashboard/RoadAccidentDashboard";
import Blackspotmap from "./components/Homepage/RoadAccident/RoadAccidentDashboard/Section1/Blackspotmap";
import ReportsRoadConditionData from "./components/Homepage/RoadAccident/RoadAccidentDashboard/Section1/ReportsRoadConditionData";
import ReportsRecords from "./components/Homepage/RoadAccident/ReportsRecords/ReportsRecords";
import DataPanelForms from "./components/Homepage/RoadAccident/DataPanelForms/DataPanelForms";

// Fire risk imports
import Infrastructure from "./components/Homepage/FireRisk/Infrastructure";
import Firms from "./components/Homepage/FireRisk/Firms/Firms";
import Population from "./components/Homepage/FireRisk/population";
import Network from "./components/Homepage/FireRisk/Network";
import Livestock from "./components/Homepage/FireRisk/Livestock";
import CFDashboard from "./components/Homepage/FireRisk/Dashboard/CFDashboard";
import ReportsFR from "./components/Homepage/FireRisk/Reports/Reports";
import FeltReportFR from "./components/Homepage/FireRisk/DataPanel/FeltReport/FeltReport";
import FeltReportFL from "./components/Homepage/Flood/DataPanel/FeltReport/FeltReport";
import LightningForms from "./components/Homepage/Lightning/DataPanel/Forms/Forms";
import Fireriskadvisory from "./components/Homepage/FireRisk/DataPanel/Firerisk_advisory/Fireriskadvisory";
import AutoEmailFR from "./components/Homepage/FireRisk/Dissemination/AutoEmail/AutoEmail";
import ForecastFR from "./components/Homepage/FireRisk/Forecast/Forecast";
import HistoricalDataFR from "./components/Homepage/FireRisk/HistoricalData/HistoricalData";

// Lightning imports
import Nowcast from "./components/Homepage/Lightning/Nowcast/Nowcast";
import RecentLightningevents from "./components/Homepage/Lightning/RecentLightiningevents/RecentLightningevents";
import Lightningadvisory from "./components/Homepage/Lightning/Advisory/Lightningadvisory";
import Statistics from "./components/Homepage/Lightning/Statistics/Statistics";
import ReportsLI from "./components/Homepage/Lightning/Reports/Reports";
import OpenmeteoJMA from "./components/Homepage/Lightning/OpenmeteoJMA/OpenmeteoJMA";
import LightningProbability from "./components/Homepage/Lightning/OpenmeteoJMA/Lightningprobability";
import Lightningadvisoryview from "./components/Homepage/Lightning/Advisory/Lightningadvisoryview";

import Fireadvisory from "./components/Homepage/FireRisk/Advisory/Fireadvisory";
import Hotspot from "./components/Homepage/FireRisk/Hotspot/Hotspot";
import Fireforecast from "./components/Homepage/FireRisk/Fireforecast/Fireforecast";
import Hospitals from "./components/Homepage/RoadAccident/Hospital/Hospitals";
import Disseminate from "./components/Homepage/Dissemination/Disseminate";
import Advisoryraview from "./components/Homepage/RoadAccident/Advisory/Advisoryraview";

import OfficialsinfoForm from "./components/Homepage/Dissemination/StaffInfo/OfficialsinfoForm";
import OfficialsProfile from "./components/Homepage/Dissemination/StaffInfo/OfficialsProfile";

import UserManagement from "./components/Homepage/AdminPanel/UserManagement/UserManagement";
import RolesPermissions from "./components/Homepage/AdminPanel/RolesPermissions/RolesPermissions";

import GoogleAnalyticsTracker from "./components/common/GoogleAnalyticsTracker";
import Floodadvisory from "./components/Homepage/Flood/DataPanel/Advisory/Floodadvisory";
import Floodadvisoryview from "./components/Homepage/Flood/DataPanel/Advisory/Floodadvisoryview";
import Eqadvisoryview from "./components/Homepage/Earthquake/Advisory/Eqadvisoryview";
import FlashDensity from "./components/Homepage/Lightning/FlashDensity/FlashDensity";
import DataManagement from "./components/Homepage/AdminPanel/DataManagement/DataManagement";
import SystemMonitoring from "./components/Homepage/AdminPanel/SystemMonitoring/SystemMonitoring";
import ForecastValueAddition from "./components/Homepage/AdminPanel/ForecastValueAddition/ForecastValueAddition";
import SituationReportHub from "./components/Homepage/AdminPanel/IncidentReports/SituationReportHub";
import ReportApprovalHub from "./components/Homepage/AdminPanel/ReportApproval/ReportApprovalHub";


// Every route below gates on a dynamic permission code (see
// login/sql/rbac_setup.sql for the full catalog and login/views.py's
// `require_permission`), fetched per-user at login time and stored in
// localStorage('permissions') by LoginPage.js. There is no hardcoded
// role-code list anywhere in this file — a Super Admin can create a brand
// new role from the Roles & Permissions screen, grant it any combination of
// these permission codes, and every route below immediately respects that
// with no frontend code change. A true Super Admin (is_superuser) bypasses
// all of these checks in ProtectedRoute.

function App() {
  // Normalize trailing slashes
  if (window.location.pathname !== '/' && window.location.pathname.endsWith('/')) {
    const cleanPath = window.location.pathname.replace(/\/+$/, '');
    const newUrl = cleanPath + window.location.search + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  return (
    <Router>
      <GoogleAnalyticsTracker trackingId="G-C3371889DG" />
      <Routes>
        {/* Public Routes */}
        <Route path="/LoginPage" element={<LoginPage />} />
        <Route path="/SignupPage" element={<SignupPage />} />
        <Route path="/ForgotPassword" element={<ForgotPasswordPage />} />

        {/* All protected inside DashboardPage */}
        <Route element={<DashboardPage />}>
          <Route path="/" element={<Home />} />
          <Route path="/Overview" element={
            <ProtectedRoute requiredPermission="dashboard_overview"><OverviewDashboard /></ProtectedRoute>
          } />
          <Route path="/ActiveEvents" element={
            <ProtectedRoute requiredPermission="dashboard_active_events"><ActiveEventsHub /></ProtectedRoute>
          } />
          <Route path="/About" element={<About />} />
          <Route path="/Disseminate" element={
            <ProtectedRoute requiredPermission="dissemination_broadcast"><Disseminate /></ProtectedRoute>
          } />

          {/* Cyclone (view vs manage vs disseminate are separate permissions) */}
          <Route path="/Cyclone/DisturbanceTrack" element={
            <ProtectedRoute requiredPermission="cyclone_disturbance_track"><DisturbanceTrack /></ProtectedRoute>
          } />
          <Route path="/Cyclone/ImpactForecast" element={
            <ProtectedRoute requiredPermission="cyclone_impact_forecast"><ImpactForecast /></ProtectedRoute>
          } />
          <Route path="/Cyclone/ImpactForecast/Overview" element={
            <ProtectedRoute requiredPermission="cyclone_impact_forecast_overview"><OverviewC /></ProtectedRoute>
          } />
          <Route path="/Cyclone/ImpactForecast/Cyclone_Advisory" element={
            <ProtectedRoute requiredPermission="cyclone_impact_forecast_advisory"><CycloneAdvisory /></ProtectedRoute>
          } />
          <Route path="/Cyclone/ImpactForecast/ImpactedArea" element={
            <ProtectedRoute requiredPermission="cyclone_impact_forecast_impacted_area"><ImpactedArea /></ProtectedRoute>
          } />
          <Route path="/Cyclone/ImpactForecast/OceanWave" element={
            <ProtectedRoute requiredPermission="cyclone_impact_forecast_ocean_wave"><OceanWave /></ProtectedRoute>
          } />
          <Route path="/Cyclone/OceanState" element={
            <ProtectedRoute requiredPermission="cyclone_ocean_state"><Oceanstate /></ProtectedRoute>
          } />
          <Route path="/Cyclone/OceanState/Forecast" element={
            <ProtectedRoute requiredPermission="cyclone_ocean_state_forecast"><Oceanstate /></ProtectedRoute>
          } />
          <Route path="/Cyclone/HistoricalCyclone" element={
            <ProtectedRoute requiredPermission="cyclone_historical_cyclone"><HistoricalCyclone /></ProtectedRoute>
          } />
          <Route path="/Cyclone/AdvisoryCyclone" element={
            <ProtectedRoute requiredPermission="cyclone_advisory"><AdvisoryCyclone /></ProtectedRoute>
          } />
          <Route path="/Cyclone/Exposure/GISMaps" element={
            <ProtectedRoute requiredPermission="cyclone_exposure_gis_maps"><GISMaps /></ProtectedRoute>
          } />
          <Route path="/Cyclone/Exposure/TopographicMap" element={
            <ProtectedRoute requiredPermission="cyclone_exposure_topographic_map"><TopographicMap /></ProtectedRoute>
          } />
          <Route path="/Cyclone/Exposure/GeneralMaps" element={
            <ProtectedRoute requiredPermission="cyclone_exposure_general_maps"><GeneralMaps /></ProtectedRoute>
          } />
          <Route path="/Cyclone/Comparison" element={
            <ProtectedRoute requiredPermission="cyclone_comparison"><Comparison /></ProtectedRoute>
          } />
          <Route path="/WeatherStation" element={
            <ProtectedRoute requiredPermission="weather_station"><WeatherStation /></ProtectedRoute>
          } />
          <Route path="/Cyclone/SatelliteImagery" element={
            <ProtectedRoute requiredPermission="cyclone_satellite_imagery"><SatelliteImagery /></ProtectedRoute>
          } />
          <Route path="/Cyclone/Reports" element={
            <ProtectedRoute requiredPermission="cyclone_report_list"><ReportsCY /></ProtectedRoute>
          } />

          {/* Dissemination (requires cyclone.disseminate — SA + Cyclone Admin by default) */}
          <Route path="/Cyclone/Dissemination/AutoEmail" element={
            <ProtectedRoute requiredPermission="cyclone_dissemination_auto_email"><AutoEmailCyclone /></ProtectedRoute>
          } />


          {/* DataPanel (requires cyclone.manage — SA + Cyclone Admin by default) */}
          <Route path="/Cyclone/DataPanel/BulletinEntry" element={
            <ProtectedRoute requiredPermission="cyclone_data_panel_bulletin_entry"><BulletinEntry /></ProtectedRoute>
          } />
          <Route path="/Cyclone/DataPanel/CycloneTrack" element={
            <ProtectedRoute requiredPermission="cyclone_data_panel_cyclone_track"><CycloneTrack /></ProtectedRoute>
          } />
          <Route path="/Cyclone/DataPanel/UploadJTWC" element={
            <ProtectedRoute requiredPermission="cyclone_data_panel_upload_jtwc"><UploadJTWC /></ProtectedRoute>
          } />
          <Route path="/Cyclone/DataPanel/Cyclone_advisory" element={
            <ProtectedRoute requiredPermission="cyclone_data_panel_advisory"><Cycloneadvisory /></ProtectedRoute>
          } />
          <Route path="/Cyclone/DataPanel/FeltReport" element={
            <ProtectedRoute requiredPermission="cyclone_data_panel_felt_report"><FeltReportCY /></ProtectedRoute>
          } />
          {/* Landslide (requires landslide.view) */}
          <Route path="/Landslide/Forecast" element={
            <ProtectedRoute requiredPermission="landslide_forecast"><ForecastLS /></ProtectedRoute>
          } />
          <Route path="/Landslide/Projections" element={
            <ProtectedRoute requiredPermission="landslide_projections"><Projections /></ProtectedRoute>
          } />
          <Route path="/Landslide/Advisory" element={
            <ProtectedRoute requiredPermission="landslide_advisory"><LandslideAdvisory /></ProtectedRoute>
          } />
          <Route path="/Landslide/ImpactForecast/Overview" element={
            <ProtectedRoute requiredPermission="landslide_impact_forecast_overview"><OverviewLS /></ProtectedRoute>
          } />
          <Route path="/Landslide/ImpactedArea_LS" element={
            <ProtectedRoute requiredPermission="landslide_impacted_area"><ImpactedAreaLS /></ProtectedRoute>
          } />
          <Route path="/Landslide/RainfallForecast" element={
            <ProtectedRoute requiredPermission="landslide_rainfall_forecast"><RainfallForecast /></ProtectedRoute>
          } />
          <Route path="/Landslide/HistoricalData" element={
            <ProtectedRoute requiredPermission="landslide_historical_data"><HistoricalDataLS /></ProtectedRoute>
          } />
          <Route path="/Landslide/GeologicalTerrainData/BathymetrySeamask" element={
            <ProtectedRoute requiredPermission="landslide_geological_terrain_bathymetry_seamask"><BathymetrySeamask /></ProtectedRoute>
          } />
          <Route path="/Landslide/GeologicalTerrainData/SoilData" element={
            <ProtectedRoute requiredPermission="landslide_geological_terrain_soil_data"><SoilData /></ProtectedRoute>
          } />
          <Route path="/Landslide/GeologicalTerrainData/LandCover" element={
            <ProtectedRoute requiredPermission="landslide_geological_terrain_land_cover"><LandCover /></ProtectedRoute>
          } />
          <Route path="/Landslide/GeologicalTerrainData/SoilTexture" element={
            <ProtectedRoute requiredPermission="landslide_geological_terrain_soil_texture"><SoilTexture /></ProtectedRoute>
          } />
          <Route path="/Landslide/Susceptibility/LSM" element={
            <ProtectedRoute requiredPermission="landslide_susceptibility_lsm"><LSM /></ProtectedRoute>
          } />
          <Route path="/Landslide/Susceptibility/SeasonalWise" element={
            <ProtectedRoute requiredPermission="landslide_susceptibility_seasonal_wise"><SeasonalWise /></ProtectedRoute>
          } />
          <Route path="/Landslide/Reports" element={
            <ProtectedRoute requiredPermission="landslide_report_list"><ReportsLS /></ProtectedRoute>
          } />
          <Route path="/Landslide/VulnerabilityLS/HydrologicalData" element={
            <ProtectedRoute requiredPermission="landslide_vulnerability_hydrological_data"><HydrologicalDataLS /></ProtectedRoute>
          } />
          <Route path="/Landslide/ExposureLS/RoadNetwork" element={
            <ProtectedRoute requiredPermission="landslide_exposure_road_network"><RoadNetwork /></ProtectedRoute>
          } />
          <Route path="/Landslide/Dissemination/AutoEmail" element={
            <ProtectedRoute requiredPermission="landslide_dissemination_auto_email"><AutoEmailLandslide /></ProtectedRoute>
          } />
          <Route path="/Landslide/DataPanel/FeltReport" element={
            <ProtectedRoute requiredPermission="landslide_data_panel_felt_report"><FeltReportLS /></ProtectedRoute>
          } />
          <Route path="/Landslide/DataPanel/Landslide_advisory" element={
            <ProtectedRoute requiredPermission="landslide_data_panel_advisory"><Landslideadvisory /></ProtectedRoute>
          } />

          {/* Earthquake (requires earthquake.view) */}
          <Route path="/Earthquake/Statistics" element={
            <ProtectedRoute requiredPermission="earthquake_statistics"><EqStatistics /></ProtectedRoute>
          } />
          {/* <Route path="/Earthquake/Statistics/EarthquakeDashboard" element={
            <ProtectedRoute requiredPermission="earthquake_statistics"><EarthquakeDashboard /></ProtectedRoute>
          } /> */}
          <Route path="/Earthquake/RecentEarthquake" element={
            <ProtectedRoute requiredPermission="earthquake_recent_earthquake"><RecentEarthquake /></ProtectedRoute>
          } />
          <Route path="/Earthquake/TsunamiThreat" element={
            <ProtectedRoute requiredPermission="earthquake_tsunami_threat"><TsunamiThreat /></ProtectedRoute>
          } />
          <Route path="/Earthquake/TsunamiThreat/RiskInformation" element={
            <ProtectedRoute requiredPermission="earthquake_tsunami_threat_risk_information"><RiskInformation /></ProtectedRoute>
          } />
          <Route path="/Earthquake/DataPanel/Advisory" element={
            <ProtectedRoute requiredPermission="earthquake_data_panel_advisory"><EQAdvisory /></ProtectedRoute>
          } />
          <Route path="/Earthquake/Advisory" element={
            <ProtectedRoute requiredPermission="earthquake_advisory"><Eqadvisoryview /></ProtectedRoute>
          } />
          <Route path="/Earthquake/FeltReport" element={
            <ProtectedRoute requiredPermission="earthquake_felt_report"><FeltReport /></ProtectedRoute>
          } />
          <Route path="/Earthquake/Reports" element={
            <ProtectedRoute requiredPermission="earthquake_report_list"><ReportList /></ProtectedRoute>
          } />
          <Route path="/Earthquake/AutoEmail" element={
            <ProtectedRoute requiredPermission="earthquake_auto_email"><AutoEmail /></ProtectedRoute>
          } />
          <Route path="/Earthquake/TifLayer" element={
            <ProtectedRoute requiredPermission="earthquake_tif_layer"><TifLayer /></ProtectedRoute>
          } />
          <Route path="/Earthquake/DataPanel/Events" element={
            <ProtectedRoute requiredPermission="earthquake_data_panel_events"><EQEvents /></ProtectedRoute>
          } />
          <Route path="/Earthquake/DataPanel/Settings" element={
            <ProtectedRoute requiredPermission="earthquake_data_panel_settings"><EQSettings /></ProtectedRoute>
          } />

          <Route path="/Earthquake/HealthCenters" element={
            <ProtectedRoute requiredPermission="earthquake_exposure_health_centers"><HealthCenters /></ProtectedRoute>
          } />

          {/* Flood (requires flood.view) */}
          <Route path="/Flood/Overview" element={
            <ProtectedRoute requiredPermission="flood_overview"><FloodOverview /></ProtectedRoute>
          } />
          <Route path="/Flood/FFGS" element={
            <ProtectedRoute requiredPermission="flood_ffgs"><FFGS /></ProtectedRoute>
          } />
          <Route path="/Flood/FlashFloodThreat" element={
            <ProtectedRoute requiredPermission="flood_flash_flood_threat"><FlashFlood /></ProtectedRoute>
          } />
          <Route path="/Flood/Dashboard" element={
            <ProtectedRoute requiredPermission="flood_dashboard"><FDashboard /></ProtectedRoute>
          } />
          <Route path="/Flood/GeoGlowsForecast" element={
            <ProtectedRoute requiredPermission="flood_geoglows_forecast"><GeoGlowsForecast /></ProtectedRoute>
          } />
          <Route path="/Flood/HydroForecast" element={
            <ProtectedRoute requiredPermission="flood_hydro_forecast"><HydroForecast /></ProtectedRoute>
          } />
          <Route path="/Flood/Advisory" element={
            <ProtectedRoute requiredPermission="flood_advisory"><Advisory /></ProtectedRoute>
          } />
          <Route path="/Flood/ClimateMonitoring" element={
            <ProtectedRoute requiredPermission="flood_climate_monitoring"><ClimateMonitoring /></ProtectedRoute>
          } />
          <Route path="/Flood/Analysis" element={
            <ProtectedRoute requiredPermission="flood_analysis"><Analysis /></ProtectedRoute>
          } />
          <Route path="/Flood/Exposure/AgriculutureData" element={
            <ProtectedRoute requiredPermission="flood_exposure_agriculture_data"><AgriculutureData /></ProtectedRoute>
          } />
          <Route path="/Flood/HydrologicalData" element={
            <ProtectedRoute requiredPermission="flood_exposure_hydrological_data"><HydrologicalData /></ProtectedRoute>
          } />
          <Route path="/Flood/AutoEmail" element={
            <ProtectedRoute requiredPermission="flood_auto_email"><AutoEmailFlood /></ProtectedRoute>
          } />
          <Route path="/Flood/Datapanel/Advisory" element={
            <ProtectedRoute requiredPermission="flood_data_panel_advisory"><Floodadvisory /></ProtectedRoute>
          } />
          <Route path="/Flood/FloodAdvisory" element={
            <ProtectedRoute requiredPermission="flood_advisory_view"><Floodadvisoryview /></ProtectedRoute>
          } />

          {/* Fire Risk (requires firerisk.view) */}
          <Route path="/Firerisk/Infrastructure" element={
            <ProtectedRoute requiredPermission="firerisk_exposure_infrastructure"><Infrastructure /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Firms" element={
            <ProtectedRoute requiredPermission="firerisk_firms"><Firms /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Population" element={
            <ProtectedRoute requiredPermission="firerisk_exposure_population"><Population /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Network" element={
            <ProtectedRoute requiredPermission="firerisk_exposure_network"><Network /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Livestock" element={
            <ProtectedRoute requiredPermission="firerisk_livestock"><Livestock /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Dashboard" element={
            <ProtectedRoute requiredPermission="firerisk_dashboard"><CFDashboard /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Advisory" element={
            <ProtectedRoute requiredPermission="firerisk_advisory"><Fireadvisory /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Hotspot" element={
            <ProtectedRoute requiredPermission="firerisk_hotspot"><Hotspot /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Forecast" element={
            <ProtectedRoute requiredPermission="firerisk_forecast"><ForecastFR /></ProtectedRoute>
          } />
          <Route path="/Firerisk/HistoricalData" element={
            <ProtectedRoute requiredPermission="firerisk_historical_data"><HistoricalDataFR /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Forecast" element={
            <ProtectedRoute requiredPermission="firerisk_forecast"><Fireforecast /></ProtectedRoute>
          } />
          <Route path="/Firerisk/DataPanel/FeltReport" element={
            <ProtectedRoute requiredPermission="firerisk_data_panel_felt_report"><FeltReportFR /></ProtectedRoute>
          } />
          <Route path="/Flood/DataPanel/FeltReport" element={
            <ProtectedRoute requiredPermission="flood_data_panel_felt_report"><FeltReportFL /></ProtectedRoute>
          } />
          <Route path="/Flood/Reports" element={
            <ProtectedRoute requiredPermission="flood_report_list"><ReportsFL /></ProtectedRoute>
          } />
          <Route path="/Lightning/DataPanel/Reports" element={
            <ProtectedRoute requiredPermission="lightning_data_panel_reports"><LightningForms /></ProtectedRoute>
          } />
          <Route path="/Firerisk/DataPanel/Firerisk_advisory" element={
            <ProtectedRoute requiredPermission="firerisk_data_panel_advisory"><Fireriskadvisory /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Reports" element={
            <ProtectedRoute requiredPermission="firerisk_report_list"><ReportsFR /></ProtectedRoute>
          } />
          <Route path="/Firerisk/Dissemination/AutoEmail" element={
            <ProtectedRoute requiredPermission="firerisk_dissemination_auto_email"><AutoEmailFR /></ProtectedRoute>
          } />


          {/* Road Accident (requires roadaccident.view) */}
          <Route path="/Roadaccident/AssistanceOnMove" element={
            <ProtectedRoute requiredPermission="roadaccident_assistance_on_move"><AssistanceOnMove /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/Overview" element={
            <ProtectedRoute requiredPermission="roadaccident_overview"><Overview /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/Hospitals" element={
            <ProtectedRoute requiredPermission="roadaccident_hospitals"><Hospitals /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/RoadNetworks" element={
            <ProtectedRoute requiredPermission="roadaccident_road_networks"><Roadnetworks /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/Exposure" element={
            <ProtectedRoute requiredPermission="roadaccident_exposure"><ExposureRA /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/Advisory" element={
            <ProtectedRoute requiredPermission="roadaccident_data_panel_advisory"><AdvisoryRA /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/RoadaccidentAdvisory" element={
            <ProtectedRoute requiredPermission="roadaccident_advisory"><Advisoryraview /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/Dashboard" element={
            <ProtectedRoute requiredPermission="roadaccident_dashboard"><RoadAccidentDashboard /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/Dashboard/BlackSpotData" element={
            <ProtectedRoute requiredPermission="roadaccident_dashboard_blackspot_data"><Blackspotmap /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/Dashboard/ReportRoadConditionData" element={
            <ProtectedRoute requiredPermission="roadaccident_dashboard_report_road_condition"><ReportsRoadConditionData /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/Reports" element={
            <ProtectedRoute requiredPermission="roadaccident_report_list"><ReportsRecords /></ProtectedRoute>
          } />
          <Route path="/Roadaccident/DataPanel/Reports" element={
            <ProtectedRoute requiredPermission="roadaccident_data_panel_reports"><DataPanelForms /></ProtectedRoute>
          } />

          {/* Lightning (requires lightning.view) */}
          <Route path="/Lightning/Nowcast" element={
            <ProtectedRoute requiredPermission="lightning_nowcast"><Nowcast /></ProtectedRoute>
          } />
          <Route path="/Lightning/RecentLightningEvents" element={
            <ProtectedRoute requiredPermission="lightning_recent_events"><RecentLightningevents /></ProtectedRoute>
          } />
          <Route path="/Lightning/Advisory" element={
            <ProtectedRoute requiredPermission="lightning_data_panel_advisory"><Lightningadvisory /></ProtectedRoute>
          } />
          <Route path="/Lightning/Lightningadvisory" element={
            <ProtectedRoute requiredPermission="lightning_advisory"><Lightningadvisoryview /></ProtectedRoute>
          } />
          <Route path="/Lightning/Statistics" element={
            <ProtectedRoute requiredPermission="lightning_statistics"><Statistics /></ProtectedRoute>
          } />
          <Route path="/Lightning/Reports" element={
            <ProtectedRoute requiredPermission="lightning_report_list"><ReportsLI /></ProtectedRoute>
          } />
          <Route path="/Lightning/Openmeteo(ECMWF)" element={
            <ProtectedRoute requiredPermission="lightning_openmeteo"><OpenmeteoJMA /></ProtectedRoute>
          } />
          <Route path="/Lightning/LightningImpact" element={
            <ProtectedRoute requiredPermission="lightning_impact"><LightningProbability /></ProtectedRoute>
          } />




          <Route path="/Dissemination/StaffInfo/OfficialsinfoForm" element={
            <ProtectedRoute requiredPermission="dissemination_staff_info_form"><OfficialsinfoForm /></ProtectedRoute>
          } />
          <Route path="/Dissemination/StaffInfo/OfficialsProfile" element={
            <ProtectedRoute requiredPermission="dissemination_staff_profile"><OfficialsProfile /></ProtectedRoute>
          } />
          <Route path="/Lightning/FlashDensity" element={
            <ProtectedRoute requiredPermission="lightning_flash_density"><FlashDensity /></ProtectedRoute>
          } />

          {/* Admin Panel */}
          <Route path="/AdminPanel/UserManagement" element={
            <ProtectedRoute requiredPermission="admin_user_management"><UserManagement /></ProtectedRoute>
          } />

          <Route path="/AdminPanel/RolesPermissions" element={
            <ProtectedRoute requiredPermission="admin_roles_permissions"><RolesPermissions /></ProtectedRoute>
          } />

          <Route path="/AdminPanel/DataManagement" element={
            <ProtectedRoute requiredPermission="admin_data_management"><DataManagement /></ProtectedRoute>
          } />

          <Route path="/AdminPanel/SystemMonitoring" element={
            <ProtectedRoute requiredPermission="admin_system_monitoring"><SystemMonitoring /></ProtectedRoute>
          } />

          <Route path="/AdminPanel/ForecastValueAddition" element={
            <ProtectedRoute requiredPermission="admin_forecast_value_addition">
              <div style={{ padding: "24px 28px", background: "#f8fafc", minHeight: "100%" }}>
                <ForecastValueAddition />
              </div>
            </ProtectedRoute>
          } />

          <Route path="/AdminPanel/IncidentReports" element={
            <ProtectedRoute requiredPermission="admin_incident_reports"><SituationReportHub /></ProtectedRoute>
          } />

          <Route path="/AdminPanel/ReportApproval" element={
            <ProtectedRoute requiredPermission="admin_report_approval"><ReportApprovalHub /></ProtectedRoute>
          } />

          {/* Catch all */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
